import isEmpty from 'lodash/isEmpty';
import { getVSMBetsDetail, setVSMBetsDetail } from '../../shared/util/utility';

export const removeBet = (bet: any) => {
	const vsmobile = window.vsmobile;
	// this.removeBetsFromLocal(bet.selectionKey);
	const localBets = getVSMBetsDetail(); // (JSON.parse(localStorage.getItem('vsmBets') || "[]"));
	if (localBets && !isEmpty(localBets)) {
		const betIndex = localBets.findIndex((item: any) => item.selectionKey === bet.selectionKey);

		localBets.splice(betIndex, 1);
		setVSMBetsDetail(localBets); // localStorage.setItem("vsmBets", JSON.stringify(localBets));
	}

	if (vsmobile && vsmobile.instance) vsmobile.instance.betsRemover.removeBet(bet.selectionKey);
};

export const removeBets = (allBets: any) => {
	const vsmobile = window.vsmobile;
	const localBets = getVSMBetsDetail();
	if (localBets && !isEmpty(localBets)) {
		localBets.length = 0;
		setVSMBetsDetail(localBets);
	}
	if (vsmobile && vsmobile.instance && vsmobile.useBWGAdapter === false) {
		vsmobile.instance.betsRemover.removeBets(allBets);
	}
};
